import {
  Autocomplete,
  Button,
  Card,
  CardContent,
  Grid,
  Divider,
  MenuItem,
  TextField,
  Typography,
  TextareaAutosize,
  Table,
  Modal,
  Box,
} from "@mui/material";
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import React, { useEffect, useState } from "react";
import ArrowBackSharpIcon from "@mui/icons-material/ArrowBackSharp";
import DeleteIcon from "@mui/icons-material/Delete";
import axios from "axios";
import { Navigate, useNavigate, useLocation } from "react-router-dom";
import HOST_URL from "../../../utils/Url";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import ToastApp from "../../../ToastApp";
import CustomLabel from "../../../CustomLable";
import api2 from "../../../utils/Url";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import { getISTDate } from "../../../utils/Constant";
import { url } from "inspector";
import api from "../../../utils/Url";
import Languages from "../../../Languages";
import { Language } from "react-transliterate";
import "react-transliterate/dist/index.css";
import TranslateTextField from "../../../TranslateTextField";

const style = {
  position: "absolute" as "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "180vh",
  height: "85vh",
  bgcolor: "#f5f5f5",
  border: "1px solid #000",
  boxShadow: 24,
  p: 4,
  borderRadius: 10,
};

type Props = {};
const unitOptions = [
  { value: 'Active', label: 'Active' },
  { value: 'Sleep', label: 'Sleep' },

];
const genderOptions = [
  { value: 'male', label: 'Male' },
  { value: 'female', label: 'Female' },

];

const EmployeeAdd = (props: Props) => {
  const { defaultValues } = getISTDate();
  const { i18n, t } = useTranslation();



  const [EmpDesignation, setEmpDesignation] = useState<any>([
    { value: "-1", label: t("text.SelectDesignation") },
  ]);
  const [Department, setDepartment] = useState<any>([
    { value: "-1", label: t("text.SelectDepartment") },
  ]);
  const [StateOption, setStateOption] = useState<any>([
    { value: "-1", label: t("text.SelectState") },
  ]);
  const [Country, setCountry] = useState<any>([
    { value: "-1", label: t("text.SelectCountry") },
  ]);
  const [City, setCity] = useState<any>([{ value: "-1", label: t("text.SelectCity") }]);
  // const [Gender, setGender] = useState<any>([
  //   { value: "-1", label: t("text.SelectGender") },
  // ]);
  // const [Role, setRole] = useState<any>([{ value: "-1", label: t("text.SelectRole") }]);

  useEffect(() => {
    getEmpDesignation();
    getDepartment();
    getState();
    getCountry();
    getDistrict();
    // setCity();
    // getGender();
    //   getRole();
  }, []);

  const getEmpDesignation = () => {
    const collectData = {
      designationId: -1,
    };
    api
      .post(
        `Designation/GetDesignationmaster`,
        collectData
      )
      .then((res) => {
        const arr = res.data.data.map((item: any) => ({
          label: item.designationName,
          value: item.designationId,
        }));
        setEmpDesignation(arr);
      });
  };

  const getDepartment = () => {
    const collectData = {
      departmentId: -1,
      "departmentName": ""
    };
    api
      .post(`Department/GetDepartmentmaster`, collectData)
      .then((res) => {
        const arr = res.data.data.map((item: any) => ({
          label: item.departmentName,
          value: item.departmentId,
        }));
        setDepartment(arr);
      });
  };


  const getState = async () => {
    const collectData = {
      "stateId": -1,
      "countryId": -1
      //"countryId": id
    };

    const response = await api.post(`State/GetStateMaster`, collectData);
    const data = response.data.data;
    const arr = [];
    for (let index = 0; index < data.length; index++) {
      arr.push({
        label: data[index]["stateName"],
        value: data[index]["stateId"],
      });
    }
    setStateOption(arr);
  };
  //   api
  //     .post(`State/GetStateMaster`, collectData)
  //     .then((res) => {
  //       const arr = res.data.data.map((item: any) => ({
  //         label: item.stateName + " - " + item.stateCode,
  //         value: item.stateId,
  //       }));
  //       setStateOption(arr);
  //     });
  // };

  const getCountry = async () => {
    const collectData = {
      countryId: -1,
    };
    const response = await api.post(`Country/GetCountryMaster`, collectData);
    const data = response.data.data;
    const arr = [];
    for (let index = 0; index < data.length; index++) {
      arr.push({
        label: data[index]["countryName"],
        value: data[index]["countryId"],
      });
    }
    setCountry(arr);
  };



  // const getCountry = () => {
  //   const collectData = {
  //     countryId: -1,
  //   };
  //   api
  //     .post(`Country/GetCountryMaster`, collectData)
  //     .then((res) => {
  //       const arr = res.data.data.map((item: any) => ({
  //         label: item.countryName,
  //         value: item.countryId,
  //       }));
  //       setCountry(arr);
  //     });
  // };

  // const getDistrict = (id: any) => {
  //   const collectData = {
  //     cityId: -1,
  //     stateId: id
  //   };
  //   api
  //     .post(`M10_District/GetDistrictMaster`, collectData)
  //     .then((res) => {
  //       const arr = res.data.data.map((item: any) => ({
  //         label: item.cityName + " - " + (item.stateName),
  //         value: item.cityId,
  //       }));
  //       setCity(arr);
  //     });
  // };
  const getDistrict = async () => {
    const collectData = {
      cityId: -1,
      stateId: -1,
    };
    const response = await api.post(`M10_District/GetDistrictMaster`, collectData);
    const data = response.data.data;
    const arr = [];
    for (let index = 0; index < data.length; index++) {
      arr.push({
        label: data[index]["cityName"],
        value: data[index]["cityId"],
      });
    }
    setCity(arr);
  };


  const [panOpens, setPanOpen] = React.useState(false);
  const [modalImg, setModalImg] = useState("");
  const [Opens, setOpen] = React.useState(false);
  const [Img, setImg] = useState("");
  const handlePanClose = () => {
    setPanOpen(false);
  };
  const modalOpenHandle = (event: any) => {
    setPanOpen(true);
    if (event === "imageFile") {
      setModalImg(formik.values.imageFile);
    }
  };

  const handlePanClose1 = () => {
    setOpen(false);
  };
  const modalOpenHandle1 = (event: any) => {
    setOpen(true);
    if (event === "signatureFile") {
      setImg(formik.values.signatureFile);
    }
  };
  const ConvertBase64 = (file: File): Promise<string> => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result as string);
      reader.onerror = (error) => reject(error);
    });
  };

  const base64ToByteArray = (base64: string): Uint8Array => {
    // Remove the data URL scheme if it exists
    const base64String = base64.split(",")[1];

    // Decode the Base64 string
    const binaryString = window.atob(base64String);
    const len = binaryString.length;
    const bytes = new Uint8Array(len);

    // Convert binary string to Uint8Array
    for (let i = 0; i < len; i++) {
      bytes[i] = binaryString.charCodeAt(i);
    }

    return bytes;
  };

  const uint8ArrayToBase64 = (uint8Array: Uint8Array): string => {
    let binary = "";
    const len = uint8Array.byteLength;
    for (let i = 0; i < len; i++) {
      binary += String.fromCharCode(uint8Array[i]);
    }
    return window.btoa(binary);
  };

  const otherDocChangeHandler = async (event: any, params: string) => {
    console.log("Image file change detected");

    if (event.target.files && event.target.files[0]) {
      const file = event.target.files[0];
      const fileNameParts = file.name.split(".");
      const fileExtension =
        fileNameParts[fileNameParts.length - 1].toLowerCase();

      if (!fileExtension.match(/(jpg|jpeg|bmp|gif|png)$/)) {
        alert(
          "Only image files (.jpg, .jpeg, .bmp, .gif, .png) are allowed to be uploaded."
        );
        event.target.value = null;
        return;
      }

      try {
        const base64Data = (await ConvertBase64(file)) as string;
        console.log("Base64 image data:", base64Data);

        // Convert Base64 to Uint8Array
        const byteArray = base64ToByteArray(base64Data);
        console.log("🚀 ~ otherDocChangeHandler ~ byteArray:", byteArray);

        // Convert Uint8Array to base64 string
        const base64String = uint8ArrayToBase64(byteArray);
        console.log("🚀 ~ otherDocChangeHandler ~ base64String:", base64String);

        // Set value in Formik
        formik.setFieldValue(params, base64String);

        let outputCheck =
          "data:image/png;base64," + formik.values.imageFile;
        console.log(outputCheck);
      } catch (error) {
        console.error("Error converting image file to Base64:", error);
      }
    }
  };
  // const ConvertBase64 = (file: Blob) => {
  //   console.log(file);
  //   return new Promise((resolve, reject) => {
  //     const fileReader = new FileReader();
  //     fileReader.readAsDataURL(file);
  //     fileReader.onload = () => {
  //       resolve(fileReader.result);
  //     };
  //     fileReader.onerror = (error) => {
  //       reject(error);
  //     };
  //   });
  // };

  // const otherDocChangeHandler = async (event:any, params:any) => {
  //     console.log("check");

  //     if (event.target.files && event.target.files[0]) {
  //       const file = event.target.files[0];
  //       const fileNameParts = file.name.split(".");
  //       const fileExtension = fileNameParts[fileNameParts.length - 1];
  //       if (!fileExtension.toLowerCase().match(/(jpg|jpeg)$/)) {
  //         alert("Only image files (jpg, jpeg) are allowed to be uploaded.");
  //         event.target.value = null;
  //         return;
  //       }

  //       const base64:any = await ConvertBase64(file);

  //       // Convert base64 to byte array
  //       const byteArray = Uint8Array.from(atob(base64.split(",")[1]), c => c.charCodeAt(0));
  //       formik.setFieldValue(params, byteArray);

  //       console.log(byteArray);
  //     }
  //   };


  // const otherDocChangeHandler = async (event: any, params: any) => {
  //   console.log("check");

  //   if (event.target.files && event.target.files[0]) {
  //     const file = event.target.files[0];
  //     const fileNameParts = file.name.split(".");
  //     const fileExtension = fileNameParts[fileNameParts.length - 1];
  //     if (!fileExtension.toLowerCase().match(/(jpg|jpeg)$/)) {
  //       alert("Only image files (jpg, jpeg) are allowed to be uploaded.");
  //       event.target.value = null;
  //       return; 
  //     }

  //     const base64 = await ConvertBase64(file);
  //     formik.setFieldValue(params, base64);
  //     console.log(base64);
  // };
  //}
  let navigate = useNavigate();

  const [toaster, setToaster] = useState(false);

  const [option, setOption] = useState([
    {
      value: "-1",
      label: t("text.SelectGender"),
    },
  ]);

  const validationSchema = Yup.object({
    empName: Yup.string().test(
      "required",
      t("text.EmpNameRequired"),
      function (value: any) {
        return value && value.trim() !== "";
      }
    ),

    empCode: Yup.string().test(
      "required",
      t("text.EmpCodeRequired"),
      function (value: any) {
        return value && value.trim() !== "";
      }
    ),

    empFatherName: Yup.string().test(
      "required",
      t("text.FatherNameRequired"),
      function (value: any) {
        return value && value.trim() !== "";
      }
    ),

    empMobileNo: Yup.string().test(
      "required",
      t("text.MobNoRequired"),
      function (value: any) {
        return value && value.trim() !== "";
      }
    ),

    empPanNumber: Yup.string()
      .matches(
        /^[A-Z]{3}[A-ZHPTCF][A-Z]\d{4}[A-Z]$/,
        'Invalid PAN format'
      )
      .required(t("text.PanNoRequired")),

    empDob: Yup.string().test(
      "required",
      t("text.DobRequired"),
      function (value: any) {
        return value && value.trim() !== "";
      }
    ),
    empJoiningDate: Yup.string().test(
      "required",
      t("text.JoiningDateRequired"),
      function (value: any) {
        return value && value.trim() !== "";
      }
    ),

    empDesignationId: Yup.string().test(
      "required",
      t("text.DesignationRequired"),
      function (value: any) {
        return value && value.trim() !== "";
      }
    ),

    empDeptId: Yup.string().test(
      "required",
      t("text.DepartmentRequired"),
      function (value: any) {
        return value && value.trim() !== "";
      }
    ),

    empPerAddress: Yup.string().test(
      "required",
      t("text.PermanentAddressRequired"),
      function (value: any) {
        return value && value.trim() !== "";
      }
    ),

    empPincode: Yup.string().test(
      "required",
      t("text.PincodeRequired"),
      function (value: any) {
        return value && value.trim() !== "";
      }
    ),

    empAddharNo: Yup.string()
      .required(t("text.AdharNoRequired"))
      .test("len", ("Aadhaar number must be exactly 12 digits"), (val: any) =>
        val ? val.replace(/\D/g, "").length === 12 : true
      ),
    email: Yup.string()
      .required(t("text.reqEmail"))
      .test(
        "is-valid-email",
        "Invalid email format",
        function (value: any) {
          const trimmedValue = value.trim();
          return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(trimmedValue);
        }
      ),
    dlno: Yup.string()
      .required(t("text.reqDLNO"))
      .test(
        "is-valid-dlno",
        "Invalid DL Number format",
        function (value: any) {
          const trimmedValue = value.trim();
          return /^(([A-Z]{2}[0-9]{2})( )|([A-Z]{2}-[0-9]{2}))((19|20)[0-9][0-9])[0-9]{7}$/.test(trimmedValue);
        }
      ),
  });


  const formik = useFormik({
    initialValues: {

      sortOrder: 0,
      checked: true,
      userId: localStorage.getItem("useR_ID"),



      "empid": 0,
      "empName": "",
      "empCode": "",
      "empPerAddress": "",
      "empLocalAddress": "",
      "empFatherName": "",
      "empspauseName": "",
      "empMotherName": "",
      "empMobileNo": "",
      "empStatus": "",
      "empPanNumber": "",
      "empAddharNo": "",
      "empDob": "",
      "empJoiningDate": "",
      "empretirementDate": "",
      "empDesignationId": 0,
      "empDeptId": 0,
      "empStateId": 0,
      "empCountryID": 0,
      "empCityId": 0,
      "empPincode": 0,
      "createdBy": "",
      "updatedBy": "",
      "createdOn": defaultValues,
      "updatedOn": defaultValues,
      //  "userId": "",
      "roleId": "",
      "imageFile": "",
      "signatureFile": "",
      "email": "",
      "dlno": "",
      "gender": "",
      "departmentName": "",
      "designationName": "",
      "empStateName": "",
      "empCountryName": "",
      "empCityName": "",
      "srno": 0,
      "empDepName": "",
      "registerModel": {
        "id": "",
        "username": "",
        "email": "user@example.com",
        "password": "1234",
        "role": ""
      },
      "userPermission": [
      ],
      // "checked": true

    },
    validationSchema: validationSchema,

    onSubmit: async (values) => {
      // console.log("Before submission formik values", values);

      // const filteredValues = Object.fromEntries(
      //   Object.entries(values).filter(([_, value]) => value !== "")
      // );

      // console.log("Before submission formik values", filteredValues);

      // Handle form submission
      try {
        const response = await api.post(
          `Employee/AddUpdateEmployee`, values
          // filteredValues
        );
        if (response.data.status === 1) {
          setToaster(false);
          toast.success(response.data.message);
          navigate("/employeeinfo/employee");
        } else {
          toast.error(response.data.message);
        }
      } catch (error) {
        setToaster(true);
        console.error("Error:", error);
        toast.error("An error occurred. Please try again.");
      }
    },
  });

  const requiredFields = [
    "empName",
    "empCode",
    "empPerAddress",
    "empFatherName",
    "empMobileNo",
    "empPanNumber",
    "empDob",
    "empJoiningDate",
    "empDesignationId",
    "empDeptId",
    "empAddharNo",
    "email",
    "empPincode"
  ];

  const back = useNavigate();

  return (
    <div>
      <div
        style={{
          padding: "-5px 5px",
          backgroundColor: "#ffffff",
          borderRadius: "5px",
          border: ".5px solid #FF7722",
          marginTop: "3vh",
        }}
      >
        <CardContent>
          <Typography
            variant="h5"
            textAlign="center"
            style={{ fontSize: "18px", fontWeight: 500 }}
          >
            {t("text.CreateEmployeeRegistration")}
          </Typography>

          <Grid item sm={4} xs={12}>
            <Typography style={{ marginTop: "-75px" }}>
              <Button
                type="submit"
                onClick={() => back(-1)}
                variant="contained"
                style={{
                  marginBottom: 15,
                  marginTop: "45px",
                  backgroundColor: "blue",
                  width: 20,
                }}
              >
                <ArrowBackSharpIcon />
              </Button>
            </Typography>
          </Grid>
          <Divider />
          <br />
          <form onSubmit={formik.handleSubmit}>
            {toaster === false ? "" : <ToastApp />}
            <Grid item xs={12} container spacing={2}>
              <Grid item lg={4} xs={12}>
                <TextField
                  id="empName"
                  name="empName"
                  label={
                    <span>
                      {t("text.EnterEmployeeName")} {" "}
                      {requiredFields.includes("empName") && (
                        <span
                          style={{
                            color: formik.values.empName ? "green" : "red",
                          }}
                        >
                          *
                        </span>
                      )}
                    </span>
                  }
                  value={formik.values.empName}
                  placeholder={t("text.EnterEmployeeName")}
                  size="small"
                  fullWidth
                  style={{
                    backgroundColor: "white",
                    borderColor:
                      formik.touched.empName && formik.errors.empName
                        ? "red"
                        : "initial",
                  }}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                />
                {formik.touched.empName && formik.errors.empName ? (
                  <div style={{ color: "red", margin: "5px" }}>
                    {formik.errors.empName}
                  </div>
                ) : null}
              </Grid>

              <Grid item lg={4} xs={12}>
                <TextField
                  id="empCode"
                  name="empCode"
                  label={
                    <span>
                      {t("text.EnterEmployeeCode")} {" "}
                      {requiredFields.includes("empCode") && (
                        <span
                          style={{
                            color: formik.values.empCode ? "green" : "red",
                          }}
                        >
                          *
                        </span>
                      )}
                    </span>
                  }
                  value={formik.values.empCode}
                  placeholder={t("text.EnterEmployeeCode")}
                  size="small"
                  fullWidth
                  style={{
                    backgroundColor: "white",
                    borderColor:
                      formik.touched.empCode && formik.errors.empCode
                        ? "red"
                        : "initial",
                  }}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                />
                {formik.touched.empCode && formik.errors.empCode ? (
                  <div style={{ color: "red", margin: "5px" }}>
                    {formik.errors.empCode}
                  </div>
                ) : null}
              </Grid>

              <Grid item lg={4} xs={12}>
                <TextField
                  id="empFatherName"
                  name="empFatherName"
                  label={
                    <span>
                      {t("text.EnterFatherName")} {" "}
                      {requiredFields.includes("empFatherName") && (
                        <span
                          style={{
                            color: formik.values.empFatherName ? "green" : "red",
                          }}
                        >
                          *
                        </span>
                      )}
                    </span>
                  }
                  value={formik.values.empFatherName}
                  placeholder={t("text.EnterFatherName")}
                  size="small"
                  fullWidth
                  style={{
                    backgroundColor: "white",
                  }}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  inputProps={{ pattern: "[A-Za-z\\s'-]*" }}
                />
                {formik.touched.empFatherName && formik.errors.empFatherName ? (
                  <div style={{ color: "red", margin: "5px" }}>
                    {formik.errors.empFatherName}
                  </div>
                ) : null}
              </Grid>



              <Grid item lg={4} xs={12}>
                <TextField
                  id="empMotherName"
                  name="empMotherName"
                  label={t("text.EnterMotherName")}
                  value={formik.values.empMotherName}
                  placeholder={t("text.EnterMotherName")}
                  size="small"
                  fullWidth
                  style={{ backgroundColor: "white" }}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                />
              </Grid>

              <Grid item lg={4} xs={12}>
                <TextField
                  id="empMobileNo"
                  name="empMobileNo"
                  inputProps={{ maxLength: 10 }}
                  label={
                    <span>
                      {t("text.EnterMobileNo")} {" "}
                      {requiredFields.includes("empMobileNo") && (
                        <span
                          style={{
                            color: formik.values.empMobileNo ? "green" : "red",
                          }}
                        >
                          *
                        </span>
                      )}
                    </span>
                  }
                  value={formik.values.empMobileNo}
                  placeholder={t("text.EnterMobileNo")}
                  size="small"
                  fullWidth
                  style={{
                    backgroundColor: "white",
                    borderColor:
                      formik.touched.empMobileNo && formik.errors.empMobileNo
                        ? "red"
                        : "initial",
                  }}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                />
                {formik.touched.empMobileNo && formik.errors.empMobileNo ? (
                  <div style={{ color: "red", margin: "5px" }}>
                    {formik.errors.empMobileNo}
                  </div>
                ) : null}
              </Grid>



              <Grid item lg={4} xs={12}>
                <TextField
                  id="email"
                  name="email"
                  label={
                    <span>
                      {t("text.EnterEmail")} {" "}
                      {requiredFields.includes("email") && (
                        <span
                          style={{
                            color: formik.values.email ? "green" : "red",
                          }}
                        >
                          *
                        </span>
                      )}
                    </span>
                  }
                  value={formik.values.email}
                  placeholder={t("text.EnterEmail")}
                  inputProps={{}}
                  size="small"
                  type="email"
                  fullWidth
                  style={{ backgroundColor: "white" }}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                />
                {formik.touched.email && formik.errors.email ? (
                  <div style={{ color: "red", margin: "5px" }}>
                    {formik.errors.email}
                  </div>
                ) : null}
              </Grid>

              <Grid item lg={4} xs={12}>
                <TextField
                  id="empPanNumber"
                  name="empPanNumber"
                  label={
                    <span>
                      {t("text.EnterPanNo")} {" "}
                      {requiredFields.includes("empPanNumber") && (
                        <span
                          style={{
                            color: formik.values.empPanNumber ? "green" : "red",
                          }}
                        >
                          *
                        </span>
                      )}
                    </span>
                  }
                  value={formik.values.empPanNumber}
                  placeholder={t("text.EnterPanNo")}
                  size="small"
                  fullWidth
                  style={{
                    backgroundColor: "white",
                    borderColor:
                      formik.touched.empPanNumber && formik.errors.empPanNumber
                        ? "red"
                        : "initial",
                  }}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                />
                {formik.touched.empPanNumber && formik.errors.empPanNumber ? (
                  <div style={{ color: "red", margin: "5px" }}>
                    {formik.errors.empPanNumber}
                  </div>
                ) : null}
              </Grid>

              <Grid item lg={4} xs={12}>
                <TextField
                  id="empAddharNo"
                  name="empAddharNo"
                  label={
                    <span>
                      {t("text.EnterAdharNumber")} {" "}
                      {requiredFields.includes("empAddharNo") && (
                        <span
                          style={{
                            color: formik.values.empAddharNo ? "green" : "red",
                          }}
                        >
                          *
                        </span>
                      )}
                    </span>
                  }
                  value={formik.values.empAddharNo}
                  placeholder={t("text.EnterAdharNumber")}
                  size="small"
                  fullWidth
                  style={{ backgroundColor: "white" }}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  inputProps={{ maxLength: 12 }}
                />
                {formik.touched.empAddharNo && formik.errors.empAddharNo ? (
                  <div style={{ color: "red", margin: "5px" }}>
                    {formik.errors.empAddharNo}
                  </div>
                ) : null}
              </Grid>

              <Grid item lg={4} xs={12}>
                <TextField
                  id="dlno"
                  name="dlno"
                  label={t("text.EnterDrivingLicense")}
                  value={formik.values.dlno}
                  placeholder={t("text.EnterDrivingLicense")}
                  size="small"
                  fullWidth
                  style={{ backgroundColor: "white" }}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                />
                {formik.touched.dlno && formik.errors.dlno ? (
                  <div style={{ color: "red", margin: "5px" }}>
                    {formik.errors.dlno}
                  </div>
                ) : null}
              </Grid>

              <Grid item lg={4} xs={12}>
                <TextField
                  id="empDob"
                  type="date"
                  name="empDob"
                  label={
                    <span>
                      {t("text.EnterDOB")} {" "}
                      {requiredFields.includes("empDob") && (
                        <span
                          style={{
                            color: formik.values.empDob ? "green" : "red",
                          }}
                        >
                          *
                        </span>
                      )}
                    </span>
                  }
                  value={formik.values.empDob}
                  placeholder={t("text.EnterDOB")}
                  size="small"
                  fullWidth
                  style={{
                    backgroundColor: "white",
                    borderColor:
                      formik.touched.empDob && formik.errors.empDob
                        ? "red"
                        : "initial",
                  }}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  InputLabelProps={{ shrink: true }}
                />
                {formik.touched.empDob && formik.errors.empDob ? (
                  <div style={{ color: "red", margin: "5px" }}>
                    {formik.errors.empDob}
                  </div>
                ) : null}
              </Grid>

              <Grid item lg={4} xs={12}>
                <TextField
                  id="empJoiningDate"
                  name="empJoiningDate"
                  type="date"
                  InputLabelProps={{ shrink: true }}
                  label={
                    <span>
                      {t("text.EnterJoiningDate")} {" "}
                      {requiredFields.includes("empJoiningDate") && (
                        <span
                          style={{
                            color: formik.values.empJoiningDate
                              ? "green"
                              : "red",
                          }}
                        >
                          *
                        </span>
                      )}
                    </span>
                  }
                  value={formik.values.empJoiningDate}
                  placeholder={t("text.EnterJoiningDate")}
                  size="small"
                  fullWidth
                  style={{
                    backgroundColor: "white",
                    borderColor:
                      formik.touched.empJoiningDate &&
                        formik.errors.empJoiningDate
                        ? "red"
                        : "initial",
                  }}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                />
                {formik.touched.empJoiningDate &&
                  formik.errors.empJoiningDate ? (
                  <div style={{ color: "red", margin: "5px" }}>
                    {formik.errors.empJoiningDate}
                  </div>
                ) : null}
              </Grid>

              <Grid item lg={4} xs={12}>
                <TextField
                  id="empretirementDate"
                  name="empretirementDate"
                  label={t("text.EnterRetirementDate")}
                  value={formik.values.empretirementDate}
                  placeholder={t("text.EnterRetirementDate")}
                  InputLabelProps={{ shrink: true }}
                  size="small"
                  type="date"
                  fullWidth
                  style={{ backgroundColor: "white" }}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                />
              </Grid>



              <Grid item lg={4} xs={12}>
                <Autocomplete
                  disablePortal
                  id="combo-box-demo"
                  options={EmpDesignation}
                  fullWidth
                  style={{
                    backgroundColor: "white",
                  }}
                  size="small"
                  // value={
                  //   option.find(
                  //     (option) => option.value === formik.values.empDesignationId
                  //   ) || null
                  // }
                  onChange={(event, newValue: any) => {
                    formik.setFieldValue("empDesignationId", newValue?.value);
                    formik.setFieldTouched("empDesignationId", true);
                    formik.setFieldTouched("empDesignationId", false);
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label={
                        <span>
                          {t("text.SelectDesignation")} {" "}
                          {requiredFields.includes("empDesignationId") && (
                            <span
                              style={{
                                color: formik.values.empDesignationId
                                  ? "green"
                                  : "red",
                              }}
                            >
                              *
                            </span>
                          )}
                        </span>
                      }
                    />
                  )}
                />
                {formik.touched.empDesignationId &&
                  formik.errors.empDesignationId ? (
                  <div style={{ color: "red", margin: "5px" }}>
                    {formik.errors.empDesignationId}
                  </div>
                ) : null}
              </Grid>


              <Grid item lg={4} xs={12}>
                <Autocomplete
                  disablePortal
                  id="combo-box-demo"
                  options={Department}
                  fullWidth
                  size="small"
                  value={
                    Department.find(
                      (option: any) => option.value === formik.values.empDeptId
                    ) || null // Ensure it's either a matching option or null
                  }
                  onChange={(event, newValue: any) => {
                    if (newValue) {
                      formik.setFieldValue("empDeptId", newValue.value);
                    } else {
                      formik.setFieldValue("empDeptId", ""); // Reset if no selection
                    }
                    formik.setFieldTouched("empDeptId", true);
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label={
                        <span>
                          {t("text.SelectDepartment")}{" "}
                          {requiredFields.includes("empDeptId") && (
                            <span
                              style={{
                                color: formik.values.empDeptId ? "green" : "red",
                              }}
                            >
                              *
                            </span>
                          )}
                        </span>
                      }
                    />
                  )}
                />
                {formik.touched.empDeptId && formik.errors.empDeptId ? (
                  <div style={{ color: "red", margin: "5px" }}>
                    {String(formik.errors.empDeptId)}
                  </div>
                ) : null}
              </Grid>
              {/* <Grid item lg={4} xs={12}>
                  <Autocomplete
                    disablePortal
                    id="combo-box-demo"
                    options={Department}
                    fullWidth
                    size="small"
                    //  value={
                    //    option.find(
                    //      (option) => option.value === formik.values.empDeptId
                    //    ) || null
                    //  }
                    onChange={(event, newValue: any) => {
                      formik.setFieldValue("empDeptId", 1);
                      formik.setFieldTouched("empDeptId", true);
                      formik.setFieldTouched("empDeptId", false);
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label={
                          <span>
                            {t("text.SelectDepartment")} {" "}
                            {requiredFields.includes("empDeptId") && (
                              <span
                                style={{
                                  color: formik.values.empDeptId
                                    ? "green":"red",
                                }}
                              >
                                *
                              </span>
                            )}
                          </span>
                        }
                      />
                    )}
                  />
                  {formik.touched.empDeptId && formik.errors.empDeptId ? (
                    <div style={{ color: "red", margin: "5px" }}>
                      {formik.errors.empDeptId}
                    </div>
                  ) : null}
                </Grid> */}


              <Grid item lg={4} xs={12}>
                <Autocomplete
                  disablePortal
                  id="combo-box-demo"
                  options={Country}
                  fullWidth
                  size="small"

                  value={
                    Country.find(
                      (option: any) => option.value === formik.values.empCountryID
                    ) || null
                  }
                  onChange={(event, newValue: any) => {
                    formik.setFieldValue("empCountryID", newValue?.value);
                    // if (newValue) {
                    //   getState(newValue?.value);
                    // }
                    formik.setFieldTouched("empCountryID", true);
                    formik.setFieldTouched("empCountryID", false);
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label={
                        <span>
                          {t("text.SelectCountry")}  {""}
                          {requiredFields.includes("empCountryID") && (
                            <span
                              style={{
                                color: formik.values.empCountryID
                                  ? "green"
                                  : "red",
                              }}
                            >
                              *
                            </span>
                          )}
                        </span>
                      }
                    />
                  )}
                />
                {formik.touched.empCountryID && formik.errors.empCountryID ? (
                  <div style={{ color: "red", margin: "5px" }}>
                    {String(formik.errors.empCountryID)}
                  </div>
                ) : null}
              </Grid>

              <Grid item lg={4} xs={12}>
                <Autocomplete
                  disablePortal
                  id="combo-box-state"
                  options={StateOption} // State options
                  fullWidth
                  size="small"
                  value={
                    // Match the selected value with the options
                    StateOption.find((option: any) => option.value === formik.values.empStateId) || null
                  }
                  onChange={(event, newValue: any) => {
                    formik.setFieldValue("empStateId", newValue?.value || null); // Update formik state
                    // if (newValue) {
                    //     getDistrict(newValue.value); // Fetch districts when state changes
                    // }
                    formik.setFieldTouched("empStateId", true); // Mark field as touched
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label={
                        <span>
                          {t("text.SelectState")}{" "}
                          {requiredFields.includes("empStateId") && (
                            <span
                              style={{
                                color: formik.values.empStateId ? "green" : "red", // Green if valid
                              }}
                            >
                              *
                            </span>
                          )}
                        </span>
                      }
                    />
                  )}
                />
              </Grid>


              <Grid item lg={4} xs={12}>
                <Autocomplete
                  disablePortal
                  id="combo-box-city"
                  options={City} // City options
                  fullWidth
                  size="small"
                  value={
                    // Match the selected value with the options
                    City.find((option: any) => option.value === formik.values.empCityId) || null
                  }
                  onChange={(event, newValue: any) => {
                    formik.setFieldValue("empCityId", newValue?.value || null); // Update formik city value
                    formik.setFieldTouched("empCityId", true); // Mark field as touched
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label={
                        <span>
                          {t("text.SelectCity")}{" "}
                          {requiredFields.includes("empCityId") && (
                            <span
                              style={{
                                color: formik.values.empCityId ? "green" : "red", // Green if valid
                              }}
                            >
                              *
                            </span>
                          )}
                        </span>
                      }
                    />
                  )}
                />
              </Grid>
              {/* <Grid item lg={4} xs={12}>
                  <Autocomplete
                    disablePortal
                    id="combo-box-demo"
                    options={Country}
                    fullWidth
                    size="small"
                    onChange={(event, newValue: any) => {
                      formik.setFieldValue("empCountryID", newValue?.value);
                      if(newValue){
                        getState(newValue?.value);
                      }
                      formik.setFieldTouched("empCountryID", true);
                      formik.setFieldTouched("empCountryID", false);
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label={
                          <span>
                            {t("text.SelectCountry")}  {""}
                            {requiredFields.includes("empCountryID") && (
                              <span
                                style={{
                                  color: formik.values.empCountryID
                                    ? "green"
                                    : "red",
                                }}
                              >
                                *
                              </span>
                            )}
                          </span>
                        }
                      />
                    )}
                  />
                  {formik.touched.empCountryID && formik.errors.empCountryID ? (
                    <div style={{ color: "red", margin: "5px" }}>
                      {formik.errors.empCountryID}
                    </div>
                  ) : null}
                </Grid>
  
                <Grid item lg={4} xs={12}>
                  <Autocomplete
                    disablePortal
                    id="combo-box-demo"
                    options={StateOption}
                    fullWidth
                    size="small"
                    onChange={(event, newValue: any) => {
                      formik.setFieldValue("empStateId", newValue?.value);
                      if(newValue){
                        getDistrict(newValue?.value);
                      }
                      formik.setFieldTouched("empStateId", true);
                      formik.setFieldTouched("empStateId", false);
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label={
                          <span>
                            {t("text.SelectState")} {""}
                            {requiredFields.includes("empStateId") && (
                              <span
                                style={{
                                  color: formik.values.empStateId
                                    ? "green"
                                    : "red",
                                }}
                              >
                                *
                              </span>
                            )}
                          </span>
                        }
                      />
                    )}
                  />
                  {formik.touched.empStateId && formik.errors.empStateId ? (
                    <div style={{ color: "red", margin: "5px" }}>
                      {formik.errors.empStateId}
                    </div>
                  ) : null}
                </Grid>
  
                <Grid item lg={4} xs={12}>
                  <Autocomplete
                    disablePortal
                    id="combo-box-demo"
                    options={City}
                    fullWidth
                    size="small"
                    onChange={(event, newValue: any) => {
                      formik.setFieldValue("empCityId", newValue?.value);
                      formik.setFieldTouched("empCityId", true);
                      formik.setFieldTouched("empCityId", false);
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label={
                          <span>
                            {t("text.SelectCity")} {""}
                            {requiredFields.includes("cityId") && (
                              <span
                                style={{
                                  color: formik.values.empCityId
                                    ? "green"
                                    : "red",
                                }}
                              >
                                *
                              </span>
                            )}
                          </span>
                        }
                      />
                    )}
                  />
               
                </Grid>  */}

              <Grid item lg={4} xs={12}>
                <Autocomplete
                  disablePortal
                  id="combo-box-demo"
                  options={genderOptions}
                  fullWidth
                  size="small"
                  // value={
                  //   option.find(
                  //     (option:any) => option.value === formik.values.gender
                  //   ) || null
                  // }

                  onChange={(event, newValue: any) => {
                    formik.setFieldValue("gender", newValue?.value + "");
                    formik.setFieldTouched("gender", true);
                    formik.setFieldTouched("gender", false);
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label={
                        <span>
                          {t("text.SelectGender")} {""}
                          {requiredFields.includes("gender") && (
                            <span
                              style={{
                                color: formik.values.gender ? "green" : "red",
                              }}
                            >
                              *
                            </span>
                          )}
                        </span>
                      }
                    />
                  )}
                />
                {formik.touched.gender && formik.errors.gender ? (
                  <div style={{ color: "red", margin: "5px" }}>
                    {formik.errors.gender}
                  </div>
                ) : null}
              </Grid>

              <Grid item lg={4} xs={12}>
                <TextField
                  id="empLocalAddress"
                  name="empLocalAddress"
                  label={t("text.EnterLocalAddress")}
                  value={formik.values.empLocalAddress}
                  placeholder={t("text.EnterLocalAddress")}
                  inputProps={{}}
                  size="small"
                  type="text"
                  fullWidth
                  style={{ backgroundColor: "white" }}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                />
              </Grid>

              <Grid item lg={4} xs={12}>
                <TextField
                  id="empPerAddress"
                  name="empPerAddress"
                  label={
                    <span>
                      {t("text.EnterPermanentAddress")} {" "}
                      {requiredFields.includes("empPerAddress") && (
                        <span
                          style={{
                            color: formik.values.empPerAddress
                              ? "green"
                              : "red",
                          }}
                        >
                          *
                        </span>
                      )}
                    </span>
                  }
                  value={formik.values.empPerAddress}
                  placeholder={t("text.EnterPermanentAddress")}
                  size="small"
                  fullWidth
                  style={{
                    backgroundColor: "white",
                    borderColor:
                      formik.touched.empPerAddress &&
                        formik.errors.empPerAddress
                        ? "red"
                        : "initial",
                  }}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                />
                {formik.touched.empPerAddress && formik.errors.empPerAddress ? (
                  <div style={{ color: "red", margin: "5px" }}>
                    {formik.errors.empPerAddress}
                  </div>
                ) : null}
              </Grid>

              <Grid item lg={4} xs={12}>
                <TextField
                  id="empPincode"
                  name="empPincode"
                  label={
                    <span>
                      {t("text.EnterPincode")} {" "}
                      {requiredFields.includes("empPincode") && (
                        <span
                          style={{
                            color: formik.values.empPincode
                              ? "green"
                              : "red",
                          }}
                        >
                          *
                        </span>
                      )}
                    </span>
                  }
                  value={formik.values.empPincode}
                  placeholder={t("text.EnterPincode")}
                  inputProps={{ maxLength: 6 }}
                  size="small"
                  type="text"
                  fullWidth
                  style={{ backgroundColor: "white" }}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                />
                {formik.touched.empPincode && formik.errors.empPincode ? (
                  <div style={{ color: "red", margin: "5px" }}>
                    {formik.errors.empPincode}
                  </div>
                ) : null}
              </Grid>
              {/* <Grid item xs={12} sm={4} lg={4}>
                                <Autocomplete
                                    disablePortal
                                    id="combo-box-demo"
                                    options={unitOptions}
                                    fullWidth
                                    size="small"
                                    onChange={(event: any, newValue: any) => {
                                        formik.setFieldValue("empStatus", newValue?.value.toString());
                                    }}
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            label={<CustomLabel text={t("text.Status")} required={false} />}
                                        />
                                    )}
                                />
                            </Grid> */}


              <Grid item lg={4} xs={12}>
                <Autocomplete
                  disablePortal
                  id="combo-box-demo"
                  options={unitOptions}
                  fullWidth
                  size="small"
                  // value={
                  //   option.find(
                  //     (option:any) => option.value === formik.values.gender
                  //   ) || null
                  // }
                  onChange={(event, newValue: any) => {
                    formik.setFieldValue("empStatus", newValue?.value + "");
                    formik.setFieldTouched("empStatus", true);
                    formik.setFieldTouched("empStatus", false);
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label={
                        <span>
                          {t("text.empStatus")} {""}
                          {requiredFields.includes("empStatus") && (
                            <span
                              style={{
                                color: formik.values.empStatus ? "green" : "red",
                              }}
                            >
                              *
                            </span>
                          )}
                        </span>
                      }
                    />
                  )}
                />
                {formik.touched.empStatus && formik.errors.empStatus ? (
                  <div style={{ color: "red", margin: "5px" }}>
                    {formik.errors.empStatus}
                  </div>
                ) : null}
              </Grid>

              <Grid container spacing={1} item>
                <Grid
                  xs={12}
                  md={4}
                  sm={4}
                  item
                  style={{ marginBottom: "30px", marginTop: "30px" }}
                >
                  <TextField
                    type="file"
                    inputProps={{ accept: "image/*" }}
                    InputLabelProps={{ shrink: true }}
                    label={
                      <strong style={{ color: "#000" }}>
                        {t("text.AttachedImage")}
                      </strong>
                    }
                    size="small"
                    fullWidth
                    style={{ backgroundColor: "white" }}
                    onChange={(e) => otherDocChangeHandler(e, "imageFile")}
                  />
                </Grid>
                <Grid xs={12} md={4} sm={4} item></Grid>

                <Grid xs={12} md={4} sm={4} item>
                  <Grid
                    style={{
                      display: "flex",
                      justifyContent: "space-around",
                      alignItems: "center",
                      margin: "10px",
                    }}
                  >
                    {formik.values.imageFile == "" ? (
                      <img
                        // src={nopdf}
                        style={{
                          width: 150,
                          height: 100,
                          border: "1px solid grey",
                          borderRadius: 10,
                        }}
                      />
                    ) : (
                      <img

                        src={"data:image/png;base64," + formik.values.imageFile}
                        style={{
                          width: 150,
                          height: 100,
                          border: "1px solid grey",
                          borderRadius: 10,
                          padding: "2px",
                        }}
                      />
                    )}
                    <Typography
                      onClick={() => modalOpenHandle("imageFile")}
                      style={{
                        textDecorationColor: "blue",
                        textDecorationLine: "underline",
                        color: "blue",
                        fontSize: "15px",
                        cursor: "pointer",
                      }}
                    >
                      {t("text.Preview")}
                    </Typography>
                  </Grid>
                </Grid>
                <Modal open={panOpens} onClose={handlePanClose}>
                  <Box sx={style}>
                    {modalImg == "" ? (
                      <img
                        //  src={nopdf}
                        style={{
                          width: "170vh",
                          height: "75vh",
                        }}
                      />
                    ) : (
                      <img
                        alt="preview image"
                        src={"data:image/png;base64," + modalImg}
                        style={{
                          width: "170vh",
                          height: "75vh",
                          borderRadius: 10,
                        }}
                      />
                    )}
                  </Box>
                </Modal>
              </Grid>

              <Grid container spacing={1} item>
                <Grid
                  xs={12}
                  md={4}
                  sm={4}
                  item
                  style={{ marginBottom: "30px", marginTop: "30px" }}
                >
                  <TextField
                    type="file"
                    inputProps={{ accept: "image/*" }}
                    InputLabelProps={{ shrink: true }}
                    label={
                      <strong style={{ color: "#000" }}>
                        {t("text.AttachedSignature")}
                      </strong>
                    }
                    size="small"
                    fullWidth
                    style={{ backgroundColor: "white" }}
                    onChange={(e) => otherDocChangeHandler(e, "signatureFile")}
                  />
                </Grid>
                <Grid xs={12} md={4} sm={4} item></Grid>

                <Grid xs={12} md={4} sm={4} item>
                  <Grid
                    style={{
                      display: "flex",
                      justifyContent: "space-around",
                      alignItems: "center",
                      margin: "10px",
                    }}
                  >
                    {formik.values.signatureFile == "" ? (
                      <img
                        //  src={nopdf}
                        style={{
                          width: 150,
                          height: 100,
                          border: "1px solid grey",
                          borderRadius: 10,
                        }}
                      />
                    ) : (
                      <img
                        src={"data:image/png;base64," + formik.values.signatureFile}
                        style={{
                          width: 150,
                          height: 100,
                          border: "1px solid grey",
                          borderRadius: 10,
                          padding: "2px",
                        }}
                      />
                    )}
                    <Typography
                      onClick={() => modalOpenHandle1("signatureFile")}
                      style={{
                        textDecorationColor: "blue",
                        textDecorationLine: "underline",
                        color: "blue",
                        fontSize: "15px",
                        cursor: "pointer",
                      }}
                    >
                      {t("text.Preview")}
                    </Typography>
                  </Grid>
                </Grid>


                <Modal open={Opens} onClose={handlePanClose1}>
                  <Box sx={style}>
                    {Img == "" ? (
                      <img
                        //  src={nopdf}
                        style={{
                          width: "170vh",
                          height: "75vh",
                        }}
                      />
                    ) : (
                      <img
                        alt="preview image"
                        src={"data:image/png;base64," + Img}
                        style={{
                          width: "170vh",
                          height: "75vh",
                          borderRadius: 10,
                        }}
                      />
                    )}
                  </Box>
                </Modal>
              </Grid>

              <Grid item lg={6} sm={6} xs={12}>
                <Grid>
                  <Button
                    type="submit"
                    fullWidth
                    style={{
                      backgroundColor: "#059669",
                      color: "white",
                      marginTop: "10px",
                    }}
                  >
                    {t("text.save")}
                  </Button>
                </Grid>
              </Grid>

              <Grid item lg={6} sm={6} xs={12}>
                <Button
                  type="reset"
                  fullWidth
                  style={{
                    backgroundColor: "#F43F5E",
                    color: "white",
                    marginTop: "10px",
                  }}
                  onClick={(e) => formik.resetForm()}
                >
                  {t("text.reset")}
                </Button>
              </Grid>

            </Grid>
          </form>
        </CardContent>
      </div>
    </div>
  );
};

export default EmployeeAdd;
